export default __webpack_public_path__ + "images/models/0ff112d42a303b554009f76302fdaa3b.glb";